import { FormField, FormFieldType } from '@enroller/admissions-components';
import { Trans, useLingui } from '@lingui/react/macro';
import { Checkbox, FormControl, FormControlLabel, Grid2, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import { Control } from 'react-hook-form';
import { useCountries } from '../contexts/CountryContext';
import { CourseReservation } from './CourseReservation';

interface Guardian1DetailsProps {
  control: Control<CourseReservation>;
  showAddress: boolean;
  onToggleAddress: (show: boolean) => void;
}

export const Guardian1Details = ({ control, showAddress, onToggleAddress }: Guardian1DetailsProps) => {
  const { t } = useLingui();
  const { countries, loading } = useCountries();
  const theme = useTheme();
  // const soleGuardianWatch = useWatch({ control, name: 'guardian1SoleGuardian' });

  const toggleSameAddress = () => {
    onToggleAddress(!showAddress);
  };

  return (
    <Grid2 container spacing={3} id="guardian-1">
      <Grid2 size={12}>
        <Typography variant="subtitle1">
          <Trans>Parent / Guardian 1 Details</Trans>
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Parent / Guardian 1 first name`} name="guardian1FirstName" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Parent / Guardian 1 last name`} name="guardian1LastName" control={control} />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          type={FormFieldType.Phone}
          label={t`Parent / Guardian 1 phone`}
          name="guardian1Phone"
          control={control}
          placeholder={t`Enter phone number (including country code)`}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField type={FormFieldType.Text} label={t`Parent / Guardian 1 email`} name="guardian1Email" control={control} />
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle1">
          <Trans>Parent / Guardian 1 Address</Trans>
        </Typography>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormControl>
          <FormControlLabel control={<Checkbox onClick={toggleSameAddress} />} label={t`Same as student's address`} />
        </FormControl>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }} sx={{ [theme.breakpoints.down('md')]: { display: 'none' } }}>
        {/* push 6 */}
      </Grid2>
      {showAddress && (
        <>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormField type={FormFieldType.Text} label={t`Street address`} name="guardian1StreetAddress" control={control} maxLength={40} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }} sx={{ [theme.breakpoints.down('md')]: { display: 'none' } }}>
            {/* push 6 */}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormField type={FormFieldType.Text} label={t`City`} name="guardian1City" control={control} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormField type={FormFieldType.Text} label={t`State / Region / Province`} name="guardian1Region" control={control} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormField type={FormFieldType.Text} label={t`Postal / Zip code`} name="guardian1PostalCode" control={control} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            {loading || countries === undefined ? (
              <Stack direction="column" justifyContent="flex-end" sx={{ height: '100%' }}>
                <Skeleton variant="rectangular" width="100%" height="48px" />
              </Stack>
            ) : (
              <FormField type={FormFieldType.Dropdown} label={t`Country`} name="guardian1Country" options={countries} control={control} />
            )}
          </Grid2>
        </>
      )}
      <Grid2 size={{ xs: 12, md: 6 }}>
        <FormField
          label={t`Are you the single legal guardian of this student?`}
          type={FormFieldType.Radio}
          name="guardian1SoleGuardian"
          control={control}
          options={[
            { label: t`Yes`, value: 'Yes' },
            { label: t`No`, value: 'No' },
          ]}
        />
      </Grid2>
      {/* TODO: file upload */}
      {/*{soleGuardianWatch === 'Yes' && (*/}
      {/*  <>*/}
      {/*    <Grid2 size={12}>*/}
      {/*      <Alert severity="info" variant="outlined">*/}
      {/*        <Trans>It is mandatory to upload this document, however this can be completed at a later stage.</Trans>*/}
      {/*      </Alert>*/}
      {/*    </Grid2>*/}
      {/*    <Grid2 size={12}>/!* TODO: file upload *!/</Grid2>*/}
      {/*  </>*/}
      {/*)}*/}
    </Grid2>
  );
};
